var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('div',{staticClass:"left-line"}),_c('h1',{attrs:{"data-text":_vm.text}},[_vm._t("default")],2),_c('div',{staticClass:"right-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }